import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((_theme) => ({
  title: {
    backgroundColor: "var(--text-primary)",
    color: "#ffffff",
    height: 65,
  },
  listItem: { padding: "12px 24px", cursor: "pointer" },
  selected: {
    backgroundColor: "var(--highlight)",
  },
}));

// https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
const languages = [
  ["nb", "Norwegian"],
  ["sv", "Swedish"],
  ["dn", "Danish"],
  ["en", "English"],
];

export default function LanguageModal(props: any) {
  const { show, onSubmit, onHide, title, chosenLanguage } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Dialog open={show} onClose={onHide} fullWidth maxWidth="sm">
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      {languages.map((languageTuple) => {
        const isoCode = languageTuple[0];
        return (
          <DialogContent
            key={isoCode}
            onClick={() => onSubmit(isoCode)}
            className={clsx(classes.listItem, chosenLanguage === isoCode && classes.selected)}
          >
            {t(languageTuple[1])}
          </DialogContent>
        );
      })}
    </Dialog>
  );
}
